import styles from "../../../styles/Components/pricing-plan/new-plans/PlanCard.module.css";
import usePricing from "../../../hooks/usePricing";
import { useSearchParams } from "react-router-dom";
import FeatureCategory from "./FeatureCategory";
import { useDispatch, useSelector } from "react-redux";
import { openSideMenu } from "../../../redux/ui/uiSlice";
import { getCheckoutLink } from "../../../redux/pricing-plan/action";
import useSubscriptionPlans from "../../../hooks/useSubscriptionPlans";
import useUserTier from "../../../hooks/useUserTier";
import { IoEarth } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { message, Modal } from "antd";
import LiteIcon from "../../../ui/icons/LiteIcon";
import FreeIcon from "../../../ui/icons/FreeIcon";
import EnterpriseIcon from "../../../ui/icons/EnterpriseIcon";
import { LuHeadphones } from "react-icons/lu";
import { RiFileList3Fill, RiShoppingBasketFill } from "react-icons/ri";

function PlanCard({ plan, expandedFeature, handleExpand }) {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const {
    proPlanMonthlyCost,
    basicPlanMonthlyCost,
    basicPlanYearlyCost,
    proPlanYearlyCost,
    yearlyDiscount,
  } = usePricing();

  const { hasSubscription, planTitle, subscriptionData, isLoading } =
    useSubscriptionPlans();

  const { isVerified, countryName, tier } = useUserTier();

  const currentPlan = planTitle;

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const duration = searchParams.get("duration") || "annual";

  const showLoading = isLoading && plan !== "Free Trial";
  const isBuyingPrevented =
    hasSubscription &&
    !subscriptionData?.isCanceled &&
    ((planTitle !== "Lite" && plan === "Lite") ||
      (planTitle === "Enterprise" && plan !== "Enterprise"));

  const isPlanActive = hasSubscription && planTitle === plan;

  const cost =
    plan === "Lite"
      ? duration === "monthly"
        ? basicPlanMonthlyCost
        : basicPlanYearlyCost
      : plan === "Pro"
        ? duration === "monthly"
          ? proPlanMonthlyCost
          : proPlanYearlyCost
        : plan === "Free Trial"
          ? "0"
          : "";

  const monthlyCost =
    plan === "Lite" ? basicPlanMonthlyCost : proPlanMonthlyCost;

  const showSideMenu = (key, scope) => {
    dispatch(openSideMenu(key, scope));
  };

  const handlePayment = () => {
    if (plan === "Free Trial") return;
    if (isLoading)
      return message.info("Hang tight! We're checking your subscription");

    if (hasSubscription && planTitle === plan) {
      return showSideMenu(plan, "subscription-info");
    } else {
      if (plan === "Enterprise") {
        return window.open("https://t.me/Mehdiravab", "_blank");
      }

      if (
        (plan === "Lite" &&
          (planTitle === "Enterprise" || planTitle === "Pro")) ||
        (plan === "Pro" && planTitle === "Enterprise")
      ) {
        return Modal.info({
          title: `You’re already on the ${planTitle} plan, so there’s no need to purchase the Lite plan.`,
          centered: true,
        });
      }
    }

    showSideMenu(plan, "plan-checkout");

    const redirectUrl = window.location.href;
    const selectedPlan =
      plan === "Lite"
        ? duration === "monthly"
          ? "monthly"
          : "yearly"
        : plan === "Pro"
          ? duration === "monthly"
            ? "monthly_pro"
            : "yearly_pro"
          : null;

    dispatch(
      getCheckoutLink(
        userData["cognito:username"],
        userData?.["custom:custom_username"],
        selectedPlan,
        redirectUrl,
        redirectUrl,
      ),
    );
  };

  return (
    <div
      className={`${styles.card} ${plan === "Lite" ? styles.popular : ""} ${currentPlan === plan ? styles.currentPlan : ""} ${!hasSubscription && plan === "Free Trial" ? styles.currentPlan : ""}`}
    >
      {((currentPlan === plan && hasSubscription) || (!hasSubscription && plan === "Free Trial")) && (
        <div
          className={styles.planStatus}
          onClick={() => {
            if (plan === "Free Trial") return;

            showSideMenu(plan, "subscription-info");
          }}
        >
          {plan !== "Free Trial" && <IoMdInformationCircleOutline />}
          Current
        </div>
      )}
      <div className={styles.cardContent}>
        <div className={styles.header}>
          <div className={styles.icon}>
            {plan === "Lite" || plan === "Pro" ? (
              <LiteIcon />
            ) : plan === "Free Trial" ? (
              <FreeIcon />
            ) : (
              <EnterpriseIcon />
            )}
          </div>
          <h4 className={styles.title}>{plan}</h4>
        </div>
        <div className={styles.price}>
          {plan !== "Enterprise" && (
            <div className={styles.cost}>
              {(duration === "monthly" || plan === "Free Trial") && (
                <h5>{Math.floor(cost * 100) / 100} USD</h5>
              )}
              {duration === "annual" && plan !== "Free Trial" && (
                <h5 className={styles.annualCost}>
                  <span>{monthlyCost}</span>
                  {Math.floor(cost * 100) / 100} USD
                </h5>
              )}
              <span> / month</span>
              {duration === "annual" && plan !== "Free Trial" && (
                <span className={styles.discount}>-{yearlyDiscount}%</span>
              )}
            </div>
          )}
          {plan !== "Free Trial" && plan !== "Enterprise" && isVerified && (
            <em className={styles.regionalDiscountInfo}>
              <IoEarth />
              Regional Price ({tier} - {countryName})
            </em>
          )}
        </div>
        <FeatureCategory
          plan={plan}
          expandedFeature={expandedFeature}
          handleExpandedFeature={handleExpand}
        />
        <div
          className={`${styles.buyBtn} ${plan === "Free Trial" ? styles.hiddenBtn : ""} ${(showLoading || isBuyingPrevented) && currentPlan !== plan ? styles.disableBtn : ""}`}
          style={{ width: "100%", textAlign: "center" }}
          onClick={handlePayment}
        >
          {plan === "Free Trial" ? (
            ""
          ) : isPlanActive ? (
            <>
              <RiFileList3Fill />
              View Details
            </>
          ) : plan === "Enterprise" ? (
            <>
              <LuHeadphones />
              Contact Us
            </>
          ) : (
            <>
              <RiShoppingBasketFill />
              Buy
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PlanCard;
